import React, { Component } from 'react';
import { Media, Button } from 'react-bootstrap';

class Video extends Component {
  renderVideoThumbnail() {
    const thumbnailUrl = this.props.thumbnailUrl;
    const videoUrl = this.props.videoUrl;

    const thumbnail = (
      <div className="video-thumbnail">
        {thumbnailUrl && (
          <img
            className="thumbnail-image"
            src={thumbnailUrl}
            alt="Video thumbnail"
          />
        )}
        <img
          className="play-icon"
          src="/images/video-play-icon.svg"
          alt="Play"
        />
      </div>
    );

    if (videoUrl) {
      return (
        <a href={videoUrl} target="_blank" rel="noopener noreferrer">
          {thumbnail}
        </a>
      );
    }

    return thumbnail;
  }

  renderVideoOverview() {
    const { title } = this.props;

    return (
      <Media.Body>
        <Media.Heading>{this.renderVideoTitle(title)}</Media.Heading>

        {this.renderWatchButton()}
      </Media.Body>
    );
  }

  renderWatchButton() {
    if (!this.props.videoUrl) return null;

    return (
      <Button
        className="download-button"
        target="_blank"
        rel="noopener noreferrer"
        href={this.props.videoUrl}
      >
        Watch
      </Button>
    );
  }

  renderVideoTitle(title) {
    const url = this.props.videoUrl;
    if (url)
      return (
        <a href={url} target="_blank" rel="noopener noreferrer">
          {title}
        </a>
      );

    return <p>{title}</p>;
  }

  render() {
    return (
      <Media className="work-item">
        <Media.Left className="hidden-sm hidden-xs" align="top">
          <div style={{ marginRight: '16px' }}>
            {this.renderVideoThumbnail()}
          </div>
        </Media.Left>

        {this.renderVideoOverview()}
      </Media>
    );
  }
}

export default Video;
